/**
 * @file automatically generated from MApp.Spatial.Ogc.Extensions.HatchPatternType
 */

export enum HatchPatternType {
    Single = 0,
    Cross = 1
}
